/** Extract permission records from GET /roles/:id */
export const extractRolePermissionIds = (response) => {
  const payload = response?.data ?? response;
  const role = payload?.data ?? payload;
  const permissions = role?.permissions ?? payload?.permissions ?? [];
  if (!Array.isArray(permissions)) return [];
  return permissions.map((p) => p.id ?? p.uuid).filter(Boolean);
};

export const GUARD_NAME_OPTIONS = [
  { value: 'user', label: 'user' },
  { value: 'admin', label: 'admin' },
  { value: 'web', label: 'web' },
  { value: 'api', label: 'api' },
];

export const buildRoleListParams = ({ page, perPage, search, guardName, paginate = 1 }) => {
  const params = { paginate };
  if (paginate) {
    params.page = page;
    params.per_page = perPage;
  }
  if (search?.trim()) {
    params.search = search.trim();
  }
  if (guardName?.trim()) {
    params['filters[guard_name]'] = guardName.trim();
  }
  return params;
};
